<template>
  <ContactList :config="config" />
</template>

<script>
import ContactList from "../../components/ContactList/ContactList.vue";

export default {
  name: "app",
  components: {
    ContactList
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
